import { PermissionAction, PermissionSubject } from '@/enums';
import {
  useUserContext,
  useUserSettingsContext,
} from '@/contexts/user-context';

export const useSalesRepMode = () => {
  const { showSalesRepUI } = useUserSettingsContext();
  const isSalesRepresentative = useIsSalesRepresentative();

  return isSalesRepresentative && showSalesRepUI;
};

export const useIsSalesRepresentative = () => {
  const { employeeCan, isGuestMode, selectedRestaurantRelationship } =
    useUserContext();

  return (
    !isGuestMode &&
    employeeCan(PermissionAction.Read, PermissionSubject.SrtPriceEditing) &&
    selectedRestaurantRelationship.salesRepModeEnabled
  );
};
